import React from 'react';

const ServerError = () => {
    return (
        <div>
            <h2>500 - SERVER ERROR</h2>
            <p>There is an error. This is all we know now.</p>
            <p>Please, <a href="/">click here to return to homepage</a>.</p>
        </div>
    );
};

export default ServerError;